module.exports = __webpack_public_path__ + "img/zin.861e2a95.png";